<template>
    <div>
        <a-row class="mt4" type="flex">
            <a-col>
                <a-input size="small" placeholder="search Text" style="width: 240px" v-if="isAddTml" v-model="tmlName"/>
                <a-select size="small" style="width: 240px" v-model="selecTmlName" @change="tmlChange"  v-else>
                    <a-select-option
                            v-for="item in tmlSelecData"
                            :value="item.uid"
                    >{{ item.templateName }}</a-select-option>
                </a-select>
            </a-col>
            <a-col v-if="!isAddTml">
                <a-tooltip placement="top">
                    <template slot="title">
                        <span>Add</span>
                    </template>
                    <img class="sbxs ml4"  src="../../../assets/img/ss-add.png"  width="22" height="22" @click="addTml">
                </a-tooltip>
            </a-col>

            <img class="ml4 sbxs" src="../../../assets/img/ss-edit.png" width="22" height="22" @click="editTml">

            <a-button class="ml4" type="danger" shape="circle" icon="rollback" size="small" v-if="isAddTml" @click="saveAddTml('close')"/>
            <a-button class="ml4" type="primary" shape="circle" icon="check" size="small" v-if="isAddTml" @click="saveAddTml"/>
            <a-popconfirm
                    v-if="!isAddTml"
                    :title="$t('generic.AreyoudeleTask')"
                    @confirm="delTml"
                    :okText="$t('generic.Yes')"
                    :cancelText="$t('generic.No')">
                <a-tooltip placement="topLeft" class="ml4">
                    <template slot="title">
                        <span>{{ $t('generic.Delete') }}</span>
                    </template>
                    <img class="sbxs" src="../../../assets/img/ss-delete.png" width="22" height="22">
                </a-tooltip>
            </a-popconfirm>
        </a-row>
        <a-row class="mt">
            <!--search 条件-->
            <a-row>
                <a-tooltip placement="top">
                    <template slot="title">
                        <span>Add</span>
                    </template>
                    <img class="sbxs"  src="../../../assets/img/ss-add.png"  width="22" height="22" @click="add">
                </a-tooltip>
                <a-tooltip placement="top">
                    <template slot="title">
                        <span>Delete</span>
                    </template>
                    <img class="sbxs ml4"  src="../../../assets/img/ss-delete.png"  width="22" height="22" @click="delTml('all')">
                </a-tooltip>
                <for-search v-for="(rule, index) in rules" :options="options" :key="rule.uid" ref="forSearchRef"    @delete-rule="deleteRule(rule.uid)"></for-search>
            </a-row>
        </a-row>
    </div>
</template>
<script>
    import ajax from '../../../api/ajax'
    import api from '../../../api/url'
    import forSearch from "./forSearch.vue"
    // eslint-disable-next-line no-unused-vars
    import { v4 as uuidv4 } from 'uuid';
    export default{
        components: {
            forSearch,
        },
        props:{
            menuTarget: {
                type: Object,
                default: function() {
                    return {};
                }
            },
        },
        data(){
            return{
                orpType: null, // add 还是编辑操作
                isAddTml: false, // 是否触发添加
                tmlName: null,
                tmlSelecData: [], // tml 下拉数据
                selecTmlName: null, //tml 当前select Name
                targetSelectDetail: {},
                rules:[],
                options: {
                    condition: [],
                    fieldNameSel: [],
                }, // advan 下拉数据
            }
        },
        created(){
            this.getAdvanceSearch()
            this.init()
        },
        methods:{
            deleteRule(targetId) {
                const index = this.rules.findIndex(rule => rule.uid === targetId);
                if (index !== -1) {
                    this.rules.splice(index, 1);
                }
            },
//            获取advance 以前的数据
            getAdvanceSearch(){
                ajax.get(api.REPORTGENERICADVANCESEARCH,{uid: this.menuTarget.uid}).then(res=>{
                    this.tmlSelecData = res.data
                    if(res.data.length > 0){
                        this.targetSelectDetail = res.data[0]
                        this.rules =res.data[0].condition ==null ? [] : JSON.parse(res.data[0].condition)
                        this.selecTmlName =  res.data[0].uid
                        for(let i in this.rules){
                            this.$nextTick(()=>{
                                this.$refs.forSearchRef[i].fillRuleStatus(this.rules[i])
                            })
                        }
                    }
                })
            },
//            添加模板
            addTml(){
                this.orpType = 'add'
                this.isAddTml = true
                this.rules = []
                this.tmlName = null
            },
//            选择tml 获取搜索条件
            tmlChange(item){
                if(item){
                    for(let i in this.tmlSelecData){
                        if(this.tmlSelecData[i].uid == item){
                            this.targetSelectDetail = this.tmlSelecData[i]
                            this.rules = JSON.parse(this.tmlSelecData[i].condition)
                            for(let i in this.rules){
                                this.$nextTick(()=>{
                                    this.$refs.forSearchRef[i].fillRuleStatus(this.rules[i])
                                })
                            }
                        }
                    }
                }
            },
//            提交tml
            saveAddTml(type){
                if(type == 'close'){
                    this.isAddTml = false
                    this.getAdvanceSearch()
                    return
                }
                //                存在不提交
                if(!this.tmlName){
                    this.$customMessage.warning('Template Name Required');
                    return
                }
//                tml 重复不提交
                if(this.orpType == 'add'){
                    for(let i in this.tmlSelecData){
                        if(this.tmlSelecData[i].templateName == this.tmlName){
                            this.$customMessage.warning('Template name existing');
                            return
                        }
                    }
                }
                let params = {
                    condition: this.querSearchVal().length > 0 ? JSON.stringify(this.querSearchVal()) : null,
                    rtMasterUid: this.menuTarget.uid,
                    templateName: this.tmlName
                }
                if(this.orpType == 'edit'){
                    params.uid = this.targetSelectDetail.uid
                    for(let i in this.tmlSelecData){
                        if(this.tmlSelecData[i].templateName == this.tmlName){
                            if(this.tmlSelecData[i].uid == this.targetSelectDetail.uid){

                            }else{
                                this.$customMessage.warning('Template name existing');
                                return
                            }
                        }
                    }
                }
                ajax.post(api.REPORTGENERICADVANCESEARCH,params).then(res=>{
                    if(res.code == 200){
                        this.orpType = null
                        this.$message.success(res.msg);
                        this.isAddTml = false
                        ajax.get(api.REPORTGENERICADVANCESEARCH,{uid: this.menuTarget.uid}).then(res=>{
                            this.tmlSelecData = res.data
                        })
                        this.selecTmlName = res.data.uid
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            delTml(type){
                if(type == 'all'){
                    this.rules = []
                    return
                }
                ajax.get(api.REPORTGENERICDELADVANCESEARCH,{uid:this.selecTmlName}).then(res=>{
                    if(res.code == 200){
                        this.$message.success(res.msg);
                        this.clearData()
                        this.getAdvanceSearch()
                    }else{
                        this.$customMessage.warning(res.msg);
                    }
                })
            },
            editTml(){
                this.isAddTml = true
                this.tmlName = this.targetSelectDetail.templateName
                this.orpType = 'edit'
            },
            init(){
                ajax.get(api.REPORTGENERICDROPADVANCESEARCH,{uid: this.menuTarget.uid}).then(res=>{
                    this.options.fieldNameSel = res.data
                })
                ajax.get(api.GETSQLDROPDATA).then(res => {
                    this.options.condition = res.data.condition;
                });
            },
            add(){
                this.rules.push({"uid":uuidv4()})
            },
            querSearchVal(){
                let arr = []
                let rules = this.rules
                for (let i = 0; i < rules.length; i++) {
                    let obj = this.$refs.forSearchRef[i].queryFormStatus()
                    arr.push(obj)
                }
                return arr
            },
            emitSearchDeail(){
                let params = {
                    condition: this.querSearchVal().length > 0 ? JSON.stringify(this.querSearchVal()) : null,
                    templateName:this.targetSelectDetail.templateName ,
                    uid: this.targetSelectDetail.uid
                }
                return params
            },
//            清除缓存
            clearData(){
                this.rules = []
                this.isAddTml = false, // 是否触发添加
                    this.tmlName = null,
                    this.selecTmlName =  null
            }
        }
    }
</script>